import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {clearPayouOrder} from '../../../../reducers/app/actions';
import PageLoader from '../../../components/loader_page';

export default ({order}) => {
    const navigate = useNavigate(),
          dispatch = useDispatch();

    if(!order)
        return <PageLoader />;

    return (
        <>
            <div className="alert">
                <div className="icon">
                    💸
                </div>

                <div className="mt10"></div>
                <div className="title">Cards</div>
                <div className="text">Your request for a <b>${order.amount}</b> is ready! All you have to do is pay for it!</div>
                <div className="text">Processing the application after payment takes <b>less than a minute!</b></div>
            
                <div className="mt40"></div>

                <div className="big-text">Unique Payment ID: <span className="text-green">{order.orderId}</span></div>
            </div>

            <div className="button blue" onClick={e => window.open(order.url, '_blank')}>Checkout page</div>

            <div className="button" onClick={e => {
                dispatch(clearPayouOrder());
                navigate('/');
            }}>Okay, thanks!</div>
        </>
    )
}